import axios from 'axios';
import Cookies from 'js-cookie';

const instance = axios.create();

instance.interceptors.request.use((config) => {
  const token = Cookies.get('authToken');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
